export const posts = [
  {
    id: "mingchangmian-top10",
    title: "年度名场面盘点：被反复回放的十个瞬间",
    categorySlug: "mingchangmian",
    excerpt: "把这一年里讨论度最高的十个画面重新排了一遍，从前三秒的铺垫到最后一秒的表情，逐个拆给你看。",
    cover: "https://readdy.ai/api/search-image?query=Warm%20coral%20and%20amber%20abstract%20stage%20spotlight%20with%20geometric%20confetti%20shapes%2C%20editorial%20magazine%20cover%20style%20illustration%2C%20soft%20cream%20background%2C%20minimal%20flat%20texture%2C%20clean%20composition&width=800&height=560&seq=gua-cover-mc01&orientation=landscape",
    author: "编辑 · 小瓜",
    date: "2026-09-08",
    readMinutes: 6,
    views: 28400,
    likes: 1920,
    tags: ["名场面", "年度盘点", "高光时刻"],
    featured: true,
    hot: true,
    highlights: [
      "十个名场面按「情绪浓度」而不是播放量重新排序，越往后越耐看。",
      "每个画面都拆解了铺垫、停顿和表情三个关键节点。",
      "附上一句话点评，方便你决定要不要回去补完整版。",
    ],
    content: [
      { type: "p", text: "名场面之所以经典，往往不是因为场面大，而是因为那一瞬间的情绪被完整地留在了镜头里。这次我们换了个标准，不看播放量，只看它能不能让人在第三遍回放时还会停下来。" },
      { type: "h2", text: "为什么这些画面值得再看一次" },
      { type: "p", text: "很多被剪进集锦的片段，第一次看只是笑一笑，第二次看才会注意到旁边人的反应。真正耐看的画面，通常有一个清晰的节奏：铺垫、停顿、爆发。少了任何一个环节，情绪都会散掉。" },
      { type: "list", items: ["铺垫够长，观众才有代入的余地", "停顿留白，让笑点有落地的空间", "收尾干脆，不拖泥带水地结束"] },
      { type: "quote", text: "好名场面不是被设计出来的，是被刚好在场的镜头接住的。" },
      { type: "h2", text: "三个最容易忽略的细节" },
      { type: "p", text: "看回放的时候，不妨把注意力从主角身上挪开一秒。很多时候，背景里那个没忍住表情的人，才是整个画面真正的点睛之笔。这也是我们把这份盘点按情绪浓度排序的原因。" },
    ],
  },
  {
    id: "mingchangmian-growth",
    title: "高光时刻图鉴：从青涩到从容的转变",
    categorySlug: "mingchangmian",
    excerpt: "把同一个人不同年份的画面并排放在一起，会发现所谓高光时刻，其实是长期积累之后自然发生的一次闪光。",
    cover: "https://readdy.ai/api/search-image?query=Timeline%20of%20warm%20orange%20and%20cream%20abstract%20shapes%20connected%20by%20thin%20lines%2C%20editorial%20minimal%20illustration%2C%20soft%20geometric%20gradient%20circles%2C%20clean%20cream%20backdrop%2C%20calm%20composition&width=800&height=560&seq=gua-cover-mc02&orientation=landscape",
    author: "编辑 · 阿乐",
    date: "2026-09-05",
    readMinutes: 5,
    views: 19700,
    likes: 1340,
    tags: ["名场面", "成长", "对比"],
    highlights: [
      "同一场景不同年份的并排对比，看得到节奏感的变化。",
      "整理出三个共性：语速、眼神和收尾方式。",
      "给正在起步的人一点平常心，高光不是一夜之间。",
    ],
    content: [
      { type: "p", text: "我们习惯把高光时刻归结为天赋或者运气，但如果把时间线拉长，会发现大多数闪光之前都有一段很长的沉默期。这次图鉴收录了六组对比画面，最早的一组间隔了七年。" },
      { type: "h2", text: "变化藏在三个小地方" },
      { type: "list", items: ["语速变慢了，但每个字更稳", "眼神从四处找镜头变成看向一个点", "收尾不再急着解释，而是留一点余味"] },
      { type: "p", text: "这些变化单独看都不起眼，放在一起就能明显感觉到从容。所谓高光，更像是长期练习之后，身体先于脑子做出的反应。" },
      { type: "quote", text: "所有的从容，都是笨拙累积到一定程度之后的副产品。" },
    ],
  },
  {
    id: "mingchangmian-bloopers",
    title: "被剪掉的名场面：彩蛋背后的故事",
    categorySlug: "mingchangmian",
    excerpt: "正片之外的花絮里，往往藏着比成片更有意思的画面。这一期我们把那些没进正片的瞬间单独拎出来聊。",
    cover: "https://readdy.ai/api/search-image?query=Backstage%20abstract%20scene%20with%20warm%20amber%20curtain%20shapes%20and%20soft%20cream%20light%2C%20editorial%20minimal%20illustration%2C%20geometric%20props%20silhouettes%2C%20clean%20warm%20backdrop%2C%20quiet%20mood&width=800&height=560&seq=gua-cover-mc03&orientation=landscape",
    author: "编辑 · 小瓜",
    date: "2026-09-02",
    readMinutes: 4,
    views: 15200,
    likes: 980,
    tags: ["名场面", "花絮", "彩蛋"],
    highlights: [
      "花絮里最真实的反应，通常发生在镜头以为已经关掉的时候。",
      "整理了三类常见彩蛋：忘词、笑场和临场改词。",
      "附上判定标准，帮你分辨哪些是设计、哪些是意外。",
    ],
    content: [
      { type: "p", text: "正片追求的是完整和流畅，所以很多有意思的边角料都会被剪掉。但对喜欢看细节的人来说，花絮反而是最有信息量的部分，因为没有排练过的反应最难伪装。" },
      { type: "h2", text: "三类最常见的彩蛋" },
      { type: "list", items: ["忘词之后的临场救场，最能看出功底", "笑场瞬间的连锁反应，通常一传一个准", "临场改词带来的意外效果，比原稿更好"] },
      { type: "p", text: "判断一个彩蛋是设计还是意外，有个很简单的方法：看周围人的反应速度。如果所有人都慢半拍才笑出来，那大概率是真的没接住。" },
      { type: "quote", text: "彩蛋的价值，在于它允许我们不完美地出现。" },
    ],
  },
  {
    id: "baoxiao-ten-moments",
    title: "笑到岔气的十个爆笑高能现场",
    categorySlug: "baoxiao",
    excerpt: "从开场到收尾全程没有冷场，这十个片段的共同点是——你以为要正经了，下一秒就绷不住。",
    cover: "https://readdy.ai/api/search-image?query=Playful%20abstract%20composition%20with%20bright%20coral%20and%20yellow%20confetti%20shapes%20and%20rounded%20speech%20bubbles%2C%20editorial%20flat%20illustration%2C%20cream%20background%2C%20energetic%20clean%20layout&width=800&height=560&seq=gua-cover-bx01&orientation=landscape",
    author: "编辑 · 阿乐",
    date: "2026-09-09",
    readMinutes: 5,
    views: 41200,
    likes: 3260,
    tags: ["爆笑高能", "合集", "综艺"],
    featured: true,
    hot: true,
    highlights: [
      "十个片段的共同点是笑点密集，平均 20 秒一个包袱。",
      "按「笑出声指数」排序，前三个建议别在安静场合看。",
      "每个片段都标了笑点出现的时间点，方便直接跳过去。",
    ],
    content: [
      { type: "p", text: "爆笑高能之所以解压，是因为它不给情绪留缓冲。正经了三分钟，突然一个意外，笑意会从胸口直接冲上来。这十个片段都是这种类型，节奏快、反应真。" },
      { type: "h2", text: "笑点为什么能连成串" },
      { type: "p", text: "单个笑点好笑不难，难的是连续好笑。观察下来，密集笑点通常靠两个东西撑着：一个是稳定的角色关系，另一个是不断升高的小意外。关系让观众有预期，意外负责打破预期。" },
      { type: "list", items: ["前 30 秒建立角色关系，观众才有代入", "每 20 秒安排一个小反转，保持节奏", "结尾用一个更大的意外收住，而不是慢慢散掉"] },
      { type: "quote", text: "最好笑的那一刻，往往是你以为已经安全了的时候。" },
    ],
  },
  {
    id: "baoxiao-live-fails",
    title: "直播翻车合集：连主持人都绷不住了",
    categorySlug: "baoxiao",
    excerpt: "直播没有剪辑，所以意外也是原汁原味的。这一期收集了几场让人替他们捏把汗的临场时刻。",
    cover: "https://readdy.ai/api/search-image?query=Minimal%20abstract%20illustration%20of%20warm%20orange%20broadcast%20signal%20waves%20and%20rounded%20screen%20frames%2C%20editorial%20flat%20style%2C%20cream%20background%2C%20playful%20geometric%20layout&width=800&height=560&seq=gua-cover-bx02&orientation=landscape",
    author: "编辑 · 小瓜",
    date: "2026-09-06",
    readMinutes: 4,
    views: 33500,
    likes: 2410,
    tags: ["爆笑高能", "直播", "名场面"],
    highlights: [
      "直播的意外无法重来，所以每一个反应都特别真实。",
      "整理了翻车之后三种常见处理方式及其效果。",
      "顺便聊聊为什么观众反而更喜欢看没有剪辑的画面。",
    ],
    content: [
      { type: "p", text: "录播可以剪，直播不能。设备突然出问题、流程临时改动、嘉宾说错话，这些在录播里会被处理掉，在直播里却会完整地留在画面中，于是就有了最真实的临场反应。" },
      { type: "h2", text: "翻车之后怎么办" },
      { type: "list", items: ["硬撑过去：风险高，但偶尔会出现意想不到的效果", "自嘲化解：最稳妥，也最容易获得好感", "直接重来：适合流程类内容，但会打断节奏"] },
      { type: "p", text: "观众其实并不排斥意外，排斥的是尴尬。只要当事人自己不慌，观众往往会把翻车当成彩蛋来看。" },
      { type: "quote", text: "直播最大的魅力，就是它拒绝被修饰。" },
    ],
  },
  {
    id: "baoxiao-silence",
    title: "综艺名场面：一句话让全场安静",
    categorySlug: "baoxiao",
    excerpt: "有些笑点不在热闹里，而在一句话说完之后突然安静的那两秒。这期聊的就是这种安静的爆笑。",
    cover: "https://readdy.ai/api/search-image?query=Quiet%20abstract%20scene%20with%20a%20single%20warm%20amber%20spotlight%20on%20an%20empty%20rounded%20podium%2C%20editorial%20minimal%20illustration%2C%20cream%20background%2C%20soft%20shadows%2C%20calm%20composition&width=800&height=560&seq=gua-cover-bx03&orientation=landscape",
    author: "编辑 · 阿乐",
    date: "2026-09-03",
    readMinutes: 4,
    views: 17800,
    likes: 1120,
    tags: ["爆笑高能", "综艺", "节奏"],
    highlights: [
      "安静的两秒，往往是全场最想笑又不敢笑的时刻。",
      "分析为什么冷场式笑点比热闹式笑点更耐回味。",
      "附上三个判断标准，看看安静是不是设计好的。",
    ],
    content: [
      { type: "p", text: "热闹的笑点靠密度，安静的笑点靠落差。一句话说完，全场突然没人接话，那种集体屏住呼吸的两秒，反而比哄堂大笑更有记忆点。" },
      { type: "h2", text: "安静为什么会更好笑" },
      { type: "p", text: "因为安静给了观众反应的时间。当所有人都在等一个回答，而回答迟迟不来的时候，观众会先替场上的人尴尬，然后尴尬转为笑意。这种由自己完成的笑点，印象会更深。" },
      { type: "quote", text: "最响的笑声，有时是从一片沉默里长出来的。" },
    ],
  },
  {
    id: "xiaotiangua-sweet",
    title: "小甜瓜时刻：甜到犯规的三个互动",
    categorySlug: "xiaotiangua",
    excerpt: "不吵不闹的轻甜内容也有它的位置。这一期挑出三个镜头边角的互动，慢慢看会不自觉笑出来。",
    cover: "https://readdy.ai/api/search-image?query=Soft%20sage%20green%20and%20cream%20abstract%20illustration%20with%20gentle%20rounded%20shapes%20and%20tiny%20heart%20motifs%2C%20editorial%20minimal%20style%2C%20airy%20clean%20composition%2C%20calm%20warm%20tone&width=800&height=560&seq=gua-cover-tg01&orientation=landscape",
    author: "编辑 · 小甜",
    date: "2026-09-07",
    readMinutes: 3,
    views: 22600,
    likes: 2180,
    tags: ["小甜瓜", "轻甜", "互动"],
    featured: true,
    highlights: [
      "三个互动都没有台词，全靠动作和眼神完成。",
      "甜度不在画面中央，而在没人注意的角落。",
      "适合睡前慢慢看，节奏很轻，不会上头。",
    ],
    content: [
      { type: "p", text: "小甜瓜和爆笑高能是两种完全不同的节奏。前者不需要你集中注意力，只要放松地看，很多温柔的细节会自己浮现出来，比如一个下意识递过去的动作。" },
      { type: "h2", text: "甜在哪三个地方" },
      { type: "list", items: ["一个没人要求、却自然而然发生的照顾动作", "一句被镜头收到但没被放大的轻声回应", "一个站在人群边缘、视线却一直跟着的瞬间"] },
      { type: "p", text: "这些画面单独看可能很平淡，但放在一起，就会形成一种很轻的暖意。它不刺激，却很耐看。" },
      { type: "quote", text: "有些甜不需要被强调，它本来就长在细节里。" },
    ],
  },
  {
    id: "xiaotiangua-corners",
    title: "被镜头捕捉到的温柔瞬间",
    categorySlug: "xiaotiangua",
    excerpt: "把注意力从主角身上移开，会发现背景里那个默默帮忙的人，才是这一期最值得看的部分。",
    cover: "https://readdy.ai/api/search-image?query=Gentle%20muted%20green%20abstract%20illustration%20with%20soft%20overlapping%20circles%20and%20thin%20delicate%20lines%2C%20editorial%20minimal%20style%2C%20cream%20background%2C%20calm%20serene%20mood&width=800&height=560&seq=gua-cover-tg02&orientation=landscape",
    author: "编辑 · 小甜",
    date: "2026-09-04",
    readMinutes: 3,
    views: 16400,
    likes: 1470,
    tags: ["小甜瓜", "细节", "温柔"],
    highlights: [
      "温柔往往不说话，只做事。",
      "整理了四个镜头边角容易被忽略的照顾动作。",
      "聊聊为什么背景里的人更容易让人有好感。",
    ],
    content: [
      { type: "p", text: "镜头习惯对准最有话题度的人，所以背景里的温柔常常被忽略。但正是这些不争不抢的细节，构成了完整画面里最让人安心的一部分。" },
      { type: "h2", text: "四个容易错过的动作" },
      { type: "list", items: ["默默把歪掉的道具扶正", "在别人紧张时轻轻拍一下肩膀", "把最亮的位置让给身边的人", "收工后顺手收拾现场"] },
      { type: "p", text: "这些动作没有台词，也拿不到镜头，但放在回放里，反而比很多高光时刻更让人记得住。" },
    ],
  },
  {
    id: "xiaotiangua-over-sweet",
    title: "甜度超标：从角落里读到的小甜瓜",
    categorySlug: "xiaotiangua",
    excerpt: "这一期专门收集那些被弹幕反复截图的角落画面，甜度可能有点超标，建议搭配一杯热水一起看。",
    cover: "https://readdy.ai/api/search-image?query=Playful%20soft%20green%20and%20cream%20abstract%20illustration%20with%20tiny%20sprinkle%20shapes%20and%20rounded%20bubbles%2C%20editorial%20minimal%20style%2C%20airy%20clean%20layout%2C%20cheerful%20calm%20tone&width=800&height=560&seq=gua-cover-tg03&orientation=landscape",
    author: "编辑 · 小甜",
    date: "2026-09-01",
    readMinutes: 4,
    views: 18300,
    likes: 1660,
    tags: ["小甜瓜", "合集", "轻甜"],
    highlights: [
      "五个被反复截图的角落画面，甜度都很克制。",
      "每张截图都标了大概的时间点，方便对照。",
      "甜度虽然高，但没有任何刻意营造的痕迹。",
    ],
    content: [
      { type: "p", text: "有些画面之所以被反复截图，不是因为有多大的信息量，而是因为看着让人舒服。这次收录的五个角落画面，基本都是这种情况。" },
      { type: "h2", text: "被截图最多的五个位置" },
      { type: "list", items: ["人群边缘的一次回头", "并排站着时不经意靠近的半步", "递东西时悬在半空的那两秒", "同时开口又同时闭嘴的默契", "散场后仍在原地停留的身影"] },
      { type: "quote", text: "被反复截图，是观众替画面做的一次投票。" },
    ],
  },
  {
    id: "lezi-weekly-01",
    title: "本周乐子合集：一杯奶茶的快乐",
    categorySlug: "lezi",
    excerpt: "一周的轻松内容打包好了，从周一到周日按心情排好顺序，随手点开一条就能接住快乐。",
    cover: "https://readdy.ai/api/search-image?query=Cheerful%20abstract%20flat%20illustration%20of%20a%20warm%20orange%20takeaway%20cup%20surrounded%20by%20rounded%20confetti%20and%20star%20shapes%2C%20editorial%20minimal%20style%2C%20cream%20background%2C%20playful%20clean%20layout&width=800&height=560&seq=gua-cover-lz01&orientation=landscape",
    author: "编辑 · 阿乐",
    date: "2026-09-10",
    readMinutes: 4,
    views: 26900,
    likes: 1980,
    tags: ["乐子合集", "周更", "轻松"],
    featured: true,
    highlights: [
      "七天七条内容，按心情从轻松到爆笑排序。",
      "每一条都控制在一分钟内能看完的长度。",
      "适合放在通勤路上，一天刷两条刚刚好。",
    ],
    content: [
      { type: "p", text: "乐子合集的思路很简单：不给压力。你不需要按顺序看，也不用担心错过前面的剧情，随便点开一条，看完就能关掉，快乐已经收到了。" },
      { type: "h2", text: "这一周的七条是怎么选的" },
      { type: "p", text: "我们从当天热度最高的内容里挑出一条节奏最舒服的。标准不是数据最好，而是看完之后心情会不会变好，这一条能不能帮你在忙碌里喘口气。" },
      { type: "list", items: ["周一：慢热型，帮你温和开机", "周三：中度笑点，撑过一周的中段", "周五：最高能的一条，配合下班情绪", "周末：轻甜收尾，留给睡前"] },
      { type: "quote", text: "快乐不用等长假，一杯奶茶的工夫就够了。" },
    ],
  },
  {
    id: "lezi-office-break",
    title: "打工人乐子图鉴：摸鱼时看什么最解压",
    categorySlug: "lezi",
    excerpt: "五到十分钟的碎片时间该看点什么？这份图鉴按「可随时中断」和「不会笑出声」两个维度做了整理。",
    cover: "https://readdy.ai/api/search-image?query=Warm%20amber%20abstract%20illustration%20of%20a%20cozy%20desk%20with%20rounded%20notebook%20and%20cup%20shapes%2C%20editorial%20minimal%20flat%20style%2C%20cream%20background%2C%20calm%20clean%20composition&width=800&height=560&seq=gua-cover-lz02&orientation=landscape",
    author: "编辑 · 小瓜",
    date: "2026-09-09",
    readMinutes: 4,
    views: 21400,
    likes: 1530,
    tags: ["乐子合集", "通勤", "碎片时间"],
    highlights: [
      "按「能不能被随时打断」给内容分了级。",
      "推荐了三类不会突然笑出声的安全内容。",
      "顺便聊聊为什么碎片时间更适合看榜单而不是长文。",
    ],
    content: [
      { type: "p", text: "摸鱼时最大的风险不是被看到，而是内容太抓人，一抬头已经过了半小时。所以碎片时间看什么，其实是一门挺实际的学问。" },
      { type: "h2", text: "三类适合摸鱼的内容" },
      { type: "list", items: ["榜单类：条理清楚，随时停下不心疼", "图鉴类：图文交替，视线容易抽离", "轻甜类：情绪平缓，不会突然笑出声"] },
      { type: "p", text: "反过来说，需要连续追更、或者笑点特别密集的内容，适合留到下班之后再慢慢看。" },
    ],
  },
  {
    id: "lezi-night-list",
    title: "深夜乐子清单：适合一个人笑出声的内容",
    categorySlug: "lezi",
    excerpt: "睡前的两小时是一天里最属于自己的时间。这份清单专门挑了不用动脑、看着就开心的内容。",
    cover: "https://readdy.ai/api/search-image?query=Cozy%20night%20abstract%20illustration%20with%20warm%20amber%20lamp%20glow%20and%20rounded%20soft%20shapes%2C%20editorial%20minimal%20style%2C%20deep%20cream%20and%20orange%20palette%2C%20calm%20serene%20mood&width=800&height=560&seq=gua-cover-lz03&orientation=landscape",
    author: "编辑 · 阿乐",
    date: "2026-09-08",
    readMinutes: 3,
    views: 15800,
    likes: 1290,
    tags: ["乐子合集", "睡前", "轻松"],
    highlights: [
      "全部内容都不需要动脑，适合疲惫的状态。",
      "推荐顺序按情绪浓度从低到高排列。",
      "附上一条小建议：睡前别刷太密集的笑点。",
    ],
    content: [
      { type: "p", text: "深夜刷内容的诉求和白天不一样。白天想要刺激，晚上更想要陪伴。这份清单里的内容都偏温和，看着看着会放松下来，而不是越来越精神。" },
      { type: "h2", text: "深夜内容的三个关键词" },
      { type: "list", items: ["节奏慢：不催促，不制造紧张", "情绪稳：看完是放松，不是亢奋", "篇幅短：三五分钟刚好，不耽误睡觉"] },
      { type: "quote", text: "好的深夜内容，会陪你安静地把一天收好。" },
    ],
  },
];